import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import LanguageSwitcher from "./LanguageSwitcher";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#0E0E12] text-white">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0E0E12]/60 border-b border-white/10">
        <div className="max-w-4xl mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
            <img src="/logo-mark.png" alt="Vixelforge" className="w-8 h-8 shrink-0" />
            <span className="font-black text-xl tracking-tight">Vixelforge</span>
          </Link>
          <LanguageSwitcher />
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-orange-400 mb-8 transition-colors" data-testid="back-link">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <h1 className="font-black text-4xl md:text-5xl tracking-tight mb-3">{title}</h1>
        <div className="text-[10px] uppercase tracking-[0.2em] text-orange-400 font-bold mb-10">Last updated {updated}</div>
        <div className="prose prose-invert prose-zinc max-w-none space-y-6 text-zinc-300 leading-relaxed">
          {children}
        </div>
      </main>
      <footer className="border-t border-white/10 py-8 px-6 mt-8">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between gap-4 text-sm text-zinc-500">
          <div className="flex items-center gap-2">
            <img src="/logo-mark.png" alt="Vixelforge" className="w-6 h-6 shrink-0" />
            <span className="font-bold text-white">Vixelforge</span>
            <span>© 2026</span>
          </div>
          <div className="flex gap-6">
            <Link to="/support" className="hover:text-white" data-testid="footer-support-link">Support</Link>
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/cookie" className="hover:text-white">Cookie</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="font-black text-2xl tracking-tight text-white mb-3 mt-8">{heading}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
